/* ag-v84.js - AquaGrip CT (v84, 27 Oct 2026, Claude)
   Studio pages: the proof strip (Material / Adhesive / Built / Shipping)
   moves under the "The pad" photo as one quiet row, and its own section is
   hidden (class agv-merged). If the spec section is missing, nothing moves. */
(function(){
  'use strict';
  if(window.__agv84) return; window.__agv84 = true;
  function merge(){
    var proof = document.querySelector('.ags-page.ag-proof');
    var lead = document.querySelector('.ags-page.ag-spec .ag-spec-lead');
    if(!proof || !lead || lead.querySelector('.agv-proofrow')) return;
    var grid = proof.querySelector('.ag-proof-grid');
    if(!grid || !grid.children.length) return;
    var row = document.createElement('div');
    row.className = 'agv-proofrow';
    Array.prototype.slice.call(grid.children).forEach(function(c){ row.appendChild(c.cloneNode(true)); });
    lead.appendChild(row);
    proof.classList.add('agv-merged');
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', merge); else merge();
})();
